import classNames from 'classnames';
import React from 'react';

import { OptionCheckmark } from '@/components/OptionCheckmark';
import { useAccount } from '@/hooks/useAccount';
import { webSubscriptionsModule } from '@/modules/subscriptions';
import { webCampaign } from '@/modules/webCampaign';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import { StripeSubscriptionData } from './components/SubscriptionData';
import './SubscriptionButton.scss';

export const SubscriptionButton: React.FC<{
  subscription: StripeV2SubscriptionPrice;
  selected: boolean;
  disabled?: boolean;
  fullDisabled?: boolean;
  renderDiscount?: boolean;
  theme?: 'dark-violet' | 'domination' | 'dark-forest' | null;
}> = ({
  subscription,
  selected,
  disabled,
  fullDisabled,
  renderDiscount,
  theme,
}) => {
  const { currentUser, user } = useAccount();
  const onboardingGender = user?.onboarding_data?.gender as
    | 'male'
    | 'female'
    | undefined;
  const onboardingIdentify = user?.onboarding_data?.identify;
  const needToRenderLabel =
    subscription.id ===
    webCampaign.getDefaulPlan(onboardingGender, onboardingIdentify);

  const plan = webSubscriptionsModule.getPlanConfig(subscription);

  const optionTheme =
    theme === 'domination'
      ? 'dark'
      : theme === 'dark-forest'
        ? 'dark-forest'
        : 'light';

  return (
    <div
      className={classNames('app-subscriptions-button', {
        selected,
        disabled: fullDisabled || disabled,
        'with-label': needToRenderLabel,
        'fully-disabled': fullDisabled,
        'theme-dark-violet': webCampaign.getStaticTheme() === 'dark-violet',
        'theme-domination': theme === 'domination',
        'theme-dark-forest': theme === 'dark-forest',
      })}
      onClick={() => {
        currentUser.setSelectedPlanId(subscription.id);
      }}
    >
      {needToRenderLabel && (
        <div
          className={classNames('app-subscriptions-button__label', {
            'theme-domination-label': theme === 'domination',
            'theme-dark-forest-label': theme === 'dark-forest',
          })}
        >
          MOST POPULAR
        </div>
      )}

      <div className={classNames('app-subscriptions-button__content')}>
        <div className="app-subscriptions-button__content-container">
          <OptionCheckmark
            checked={selected}
            className="app-subscriptions-button__checkmark"
            theme={optionTheme}
          />

          <StripeSubscriptionData
            plan={plan}
            planId={subscription.id}
            soldOut={fullDisabled}
            renderDiscount={renderDiscount}
          />
        </div>
      </div>
    </div>
  );
};
